import { SelectType } from '@ui/src';
import GeneralUserInfoRow from './general-user-info-row';
import { GeneralInfoUserProductsTypes } from '../types';

import cn from '../styles.module.css';

const GeneralUserInfoProducts = ({
  baseUserInformation,
  control,
  edit,
  errors,
  productsIndividual,
}: GeneralInfoUserProductsTypes) => (
  <div
    className={cn.generalUserInfoBlock}
    style={{ position: 'relative', zIndex: 9 }}
  >
    {!edit && (
      <div className={cn.productsRow}>
        <div className={cn.productsRowTitle}>Products</div>
        <div className={cn.productsRowContent}>
          {productsIndividual
            ?.filter((item) => {
              let result;

              if (
                baseUserInformation?.products?.find(
                  (product) => product === item.value,
                )
              ) {
                result = item;
              }

              return result;
            })
            .map((item) => (
              <div className={cn.productRowItem} key={item.value}>
                {item.name}
              </div>
            ))}
        </div>
      </div>
    )}
    {edit && (
      <GeneralUserInfoRow
        title="Products"
        control={control}
        type="select"
        disabled={!edit}
        name="productIds"
        selectType={SelectType.MULTIPLE}
        defaultValue={productsIndividual
          ?.filter((item) => {
            let result;

            if (
              baseUserInformation?.products?.find(
                (product) => product === item.value,
              )
            ) {
              result = item;
            }

            return result;
          })
          .map((item) => item.name)
          .join(', ')}
        list={productsIndividual}
        error={errors?.productIds?.message}
      />
    )}
  </div>
);

export default GeneralUserInfoProducts;
